// extracted by mini-css-extract-plugin
module.exports = {"subNavigation":"_1WtPgsVKuj4pt5E4FanTS5","mainHeader":"_2YjhiPWOWSN2BEef87I4Dd","searchAndUpload":"_1iDyHDA8_KjENQ5nRbErGs","uploadButtonDescription":"_2Z7fwZyTPeEzSwmB9Z48Sf"};